import React from 'react';
import { hashCode } from './String';
import WaypointMarker from './WaypointMarker';
import useMap from './useMap';
import { Palette } from './Palette';
const createWaypoints = (waypoints, map) => new google.maps.Polyline({
    path: waypoints?.sort((a, b) => a.sequenceNumber - b.sequenceNumber)?.map((e) => e.location),
    geodesic: true,
    strokeColor: Palette.FlightPath,
    strokeOpacity: 1.0,
    strokeWeight: 5,
    map,
});
const createWaypointShadows = (waypoints, map) => new google.maps.Polyline({
    path: waypoints?.sort((a, b) => a.sequenceNumber - b.sequenceNumber)?.map((e) => e.location),
    geodesic: true,
    strokeColor: 'black',
    strokeOpacity: 0.1,
    strokeWeight: 10,
    map,
});
function useWaypoints(waypoints, draggable, onDragEnd) {
    const { map } = useMap();
    const ref = React.useRef(new Map());
    const [refreshKey, setRefreshKey] = React.useState();
    const shapes = React.useRef(new Map());
    React.useEffect(() => {
        if (!map) {
            return;
        }
        const oldKeys = new Set([...shapes.current.keys()]);
        const newKeys = new Map([
            [hashCode(JSON.stringify(waypoints || '')), waypoints || undefined],
        ]);
        let updated = false;
        [...oldKeys]
            .filter((e) => !newKeys.has(e))
            .forEach((e) => {
            ref.current.delete(e);
            shapes.current?.get(e)?.setMap(null);
            shapes.current?.delete(e);
            shapes.current?.get(-e)?.setMap(null);
            shapes.current?.delete(-e);
            updated = true;
        });
        [...newKeys]
            .filter((e) => !oldKeys.has(e[0]) || !shapes.current.has(e[0]))
            .forEach((e) => {
            const key = e[0];
            const object = e[1];
            if (!object) {
                return;
            }
            ref.current.set(key, object);
            const newObject = createWaypoints(object, map);
            const newObjectShadow = createWaypointShadows(object, map);
            shapes.current.set(key, newObject);
            shapes.current.set(-key, newObjectShadow);
            updated = true;
        });
        if (updated) {
            setRefreshKey(Math.random());
        }
    }, [waypoints, shapes, ref, map]);
    const markers = React.useMemo(() => [...ref.current.values()].map((waypoints) => waypoints
        ?.filter((w) => !!w && !!w.location)
        ?.map((waypoint) => (React.createElement(WaypointMarker, { key: waypoint.id, id: waypoint.sequenceNumber + 1, position: waypoint.location, draggable: draggable, onDragEnd: onDragEnd ? (coords) => onDragEnd(waypoint.id, coords) : undefined, waypointId: waypoint.id })))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ref, refreshKey, draggable, onDragEnd]);
    return { markers };
}
export default useWaypoints;
